<div class="tags-container">
  <div class="d-flex overflow-auto" (focusin)="onInput($event)">
    <span class="tag" *ngFor="let tagId of selected">
      {{ getOptionName(tagId) }}
      <span (click)="removeTag(tagId)">×</span>
    </span>
    <input type="text" [placeholder]="placeholder" [(ngModel)]="inputValue"  (keydown.enter)="onAddNewTag()"/>
  </div>
  <div class="dropdown" *ngIf="filteredOptions?.length && focusOn">
    <div class="dropdown-item" *ngFor="let opt of filteredOptions" (click)="addTag(opt)">
      {{ opt.name }}
    </div>
  </div>
</div>